

import { Control } from 'react-hook-form';
import { ProfileFormValues } from '../ProfileFormSchema';
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';

type CustomBeltFieldProps = {
  control: Control<ProfileFormValues>;
  show: boolean;
};

export function CustomBeltField({ control, show }: CustomBeltFieldProps) {
  if (!show) return null;
  
  return (
    <FormField
      control={control}
      name="custom_belt"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Custom Belt Description</FormLabel>
          <FormControl>
            <Textarea 
              placeholder="Enter your belt details (e.g., Green/White kids belt)" 
              className="resize-none" 
              {...field} 
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
